<template>
  <el-form ref="BidWeChatTestForm" :rules="rules" :model="form" label-width="96px">
    <el-form-item label="消息类型：" prop="MsgType">
      <el-select size="medium" style="width:379px" placeholder="请选择消息类型" clearable v-model="form.MsgType">
        <el-option label="待办消息" :value="1"></el-option>
        <el-option label="待阅消息" :value="2"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="消息来源：" prop="MsgSource">
      <el-input size="medium" style="width:379px" placeholder="请输入消息来源" clearable v-model="form.MsgSource"></el-input>
    </el-form-item>
    <el-form-item label="消息标题：" prop="MsgTitle">
      <el-input size="medium" style="width:379px" placeholder="请输入消息标题" clearable v-model="form.MsgTitle"></el-input>
    </el-form-item>
    <el-form-item label="消息正文：" prop="MsgContent">
      <el-input size="medium" :autosize='{ minRows: 4, maxRows: 4 }' type="textarea" style="width:379px" placeholder="请输入消息正文" v-model="form.MsgContent"></el-input>
    </el-form-item>
    <el-form-item label="跳转地址：" prop="MsgCallbackUrl">
      <el-input size="medium" style="width:379px" placeholder="请输入跳转地址" v-model="form.MsgCallbackUrl"></el-input>
    </el-form-item>
    <el-form-item label="推送对象：" prop="TodoUserName">
      <el-input size="medium" style="width:379px" disabled v-model="form.TodoUserName"></el-input>
    </el-form-item>
    <div style="text-align: center;margin-top: 10px;">
      <el-button size="medium" type="primary" @click="send" :loading='sendLoad'>推送测试消息至企业微信</el-button>
    </div>
  </el-form>
</template>
<script>
import { SendMsg } from "../../http/api";
export default {
  name: "BindWeChatTest",
  props: ['userName'],
  data() {
    return {
      sendLoad: false,
      form: {
        MsgType: null,
        MsgSource: "",
        MsgTitle: "",
        MsgContent: "",
        MsgCallbackUrl: "",
        TodoUserName: "",
        TodoUserId: JSON.parse(localStorage.getItem('userInfo')).UserId
      },
      rules: {
        MsgType: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }],
        MsgSource: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }],
        MsgTitle: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }],
        MsgContent: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }],
        MsgCallbackUrl: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }],
        TodoUserName: [{ required: true, message: '不能为空！', trigger: ['change', 'blur'] }]
      }
    }
  },
  created() {
    this.form.TodoUserName = this.userName;
  },
  methods: {
    send() {
      this.$refs.BidWeChatTestForm.validate(valid => {
        if (valid) {
          this.sendLoad = true;
          SendMsg(this.form).then(res => {
            this.$message.success('消息推送成功，请前往企业微信查看')
          }).finally(() => {
            this.sendLoad = false;
          })
        }
      });
    }
  }
}
</script>
<style scoped>
</style>